import moment from 'moment-timezone'
import 'moment/locale/pt-br'
import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment)

export const groupBy = (list, keyGetter) => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

export const getDate = (date, timeZone = 'America/Sao_Paulo') => {
  return date !== undefined ? moment.utc(date).tz(timeZone) : null
}

export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  return date !== undefined ? date.format(format) : null
}

export const humanizeDate = (date) => {
  return date !== undefined ? date.fromNow() : null
}

// Brazil timezone utility functions
export const BRAZIL_TIMEZONE = 'America/Sao_Paulo'

export const formatDateBrazil = (date, format = 'DD/MM/YYYY HH:mm') => {
  if (!date) return null
  return moment.utc(date).tz(BRAZIL_TIMEZONE).format(format)
}

export const getDateBrazil = (date) => {
  return date !== undefined ? moment.utc(date).tz(BRAZIL_TIMEZONE) : null
}

export const formatDateBrazilShort = (date) => {
  return formatDateBrazil(date, 'DD/MM/YYYY')
}

export const formatTimeBrazil = (date) => {
  return formatDateBrazil(date, 'HH:mm:ss')
}

export const isExternalLink = (link) => /^https?:\/\//i.test(String(link || ''))

export const openNotificationLink = (link, history) => {
  if (!link) return

  if (isExternalLink(link)) {
    window.open(link, '_blank', 'noopener,noreferrer')
    return
  }

  if (history?.push) {
    history.push(link)
    return
  }

  window.location.assign(link)
}
